window.Index.OceanIndex = {
  usecases: ($$, $this) =>
    class UsecasesView extends Backbone.View
      events:
        'click .js-expandable': (event) ->
          @$(event.target).closest('.js-usecase').find('.js-usecase-content').slideToggle('fast')

    new UsecasesView el: $this

}